<template>
  <v-dialog
    v-model="dialog"
    width="768px"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        rounded
      >
        <v-icon left>
          mdi-qrcode-scan
        </v-icon>
        Check-In QR Code
      </v-btn>
    </template>

    <v-card shaped>
      <v-row>
        <v-col class="pb-0 d-flex align-center">
          <v-card-title>
            Check-In QR Code
          </v-card-title>
        </v-col>
        <v-col class="shrink pb-0 d-flex align-center">
          <v-btn rounded text @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="pt-0">
          <v-card-text class="pt-0">
            Attendees who are signed up for this session can scan this QR code to check-in. Put it on a slide, send it in an email, or print it out for your attendees to scan. If you don't want attendees to check themselves in, do not provide them with this code.
          </v-card-text>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex justify-center align-center">
          <img :src="this.qrCodeImgSrc" />
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card-actions class="d-flex justify-end">
            <v-btn text rounded @click="dialog = false">
              Close
            </v-btn>
            <v-btn text rounded color="primary">
              <a :href="qrCodeImgSrc" download="QRcode.png">
                <v-icon left>mdi-cloud-download</v-icon> Download
              </a>
            </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-card>

  </v-dialog> 
</template>

<script>
import QRCode from 'qrcode'

export default {
  name: 'CheckInQRCode',

  props: {
    session: Object
  },

  data: () => ({
    dialog: false,
    qrCodeImgSrc: null
  }),

  created () {
    QRCode.toDataURL(`${ window.location.origin }/check-in?session=${this.session.id}`)
    .then(imgSrc => {
      this.qrCodeImgSrc = imgSrc
    })
    .catch(err => {
      this.qrCodeImgSrc = err
    })
  },
}
</script>
